class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.cachedMap = new Map();
    this.focusElement = this.input;

    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
    this.header = document.querySelector('header');
    this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');
    this.headerMenu = document.querySelector('.header__menu.flex');
    this.toggleSearchButton = this.querySelector('.togglesearch');
    this.submitButton = this.querySelector('.search__submit');
    this.searchField = this.querySelector('.search__field');

    this.isHeaderSearch = this.closest('header') !== null;
    this.isSearchVisible = false;

    this.states = {
      OPEN: 'predictive-search-open',
      LOADING: 'btn--loading',
      SEARCH_OPEN: 'search-open',
      ACTIVE: 'predictive-search-active',
    };

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);

    this.resetButton?.addEventListener('click', this.clear.bind(this));
    this.input?.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input?.addEventListener('focus', this.onFocus.bind(this));
    this.searchProductTypes?.addEventListener('change', this.handleProductTypeChange.bind(this));
    this.toggleSearchButton?.addEventListener('click', this.handleToggleSearch.bind(this));

    document.addEventListener('click', this.boundHandleClickOutside);

    if (this.headerMenu) {
      this.headerMenu.addEventListener('mouseenter', () => {
        this.closeSearchUI();
      });
    }

    document.addEventListener('menu-drawer:open', () => {
      this.closeSearchUI();
    });

    this.updateSearchVisibility(false);
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }

  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  get searchProductTypes() {
    return this.querySelector('#SearchProductTypes');
  }

handleToggleSearch(event) {
  event.preventDefault();

  const icons = document.querySelectorAll('.togglesearch');

  if (this.isSearchVisible) {
    // Show icon again when closing (optional)
    icons.forEach(el => el.style.display = '');
    
    this.closeSearchUI();
    return;
  }

  // Hide icon when opening
  icons.forEach(el => el.style.display = 'none');

  this.openSearchUI();
}

  openSearchUI() {
    this.isSearchVisible = true;
    this.updateSearchVisibility(true);

    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `100px`
      );
    }

    if (this.isHeaderSearch) {
      document.body.classList.add(this.states.SEARCH_OPEN);
      this.toggleNavButtonVisibility(false);
    }

    this.classList.add(this.states.OPEN);
    this.input?.focus();

    const query = this.getQuery();

    if (!this.searchRecommendationEmpty) {
      this.searchContent?.classList.remove('hidden');
    }

    if (query.length === 0) {
      if (this.searchRecommendationEmpty) {
        this.searchContent?.classList.add('hidden');
      }
      return;
    }

    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  closeSearchUI() {
    this.isSearchVisible = false;
    this.toggleSearchState(false);
    this.updateSearchVisibility(false);
    this.input?.blur();
    
  const icons = document.querySelectorAll('.togglesearch');

 

  // Hide icon when opening
  icons.forEach(el => el.style.display = 'flex');
  }

  updateSearchVisibility(isVisible) {
    this.classList.toggle(this.states.ACTIVE, isVisible);

    if (this.input) {
      this.input.classList.toggle('hidden', !isVisible);
      this.input.setAttribute('aria-hidden', String(!isVisible));
      this.input.tabIndex = isVisible ? 0 : -1;
    }

    if (this.resetButton) {
      this.resetButton.classList.toggle('hidden', !isVisible);
      this.resetButton.setAttribute('aria-hidden', String(!isVisible));
      this.resetButton.tabIndex = isVisible ? 0 : -1;
    }

    if (this.submitButton) {
      this.submitButton.classList.toggle('hidden', !isVisible);
      this.submitButton.setAttribute('aria-hidden', String(!isVisible));
      this.submitButton.tabIndex = isVisible ? 0 : -1;
    }

    if (!isVisible) {
      this.searchContent?.classList.add('hidden');
    }
  }

  onFocus() {
    if (!this.isSearchVisible) return;

    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `100px`
      );
    }

    if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
      document.body.classList.add(this.states.SEARCH_OPEN);
      this.toggleNavButtonVisibility(false);
    }

    if (!this.searchRecommendationEmpty) {
      this.searchContent?.classList.remove('hidden');
    }

    this.classList.add(this.states.OPEN);

    if (this.getQuery().length === 0) {
      if (this.searchRecommendationEmpty) {
        this.searchContent?.classList.add('hidden');
      }
      return;
    }

    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  getQuery() {
    return this.input?.value.trim() || '';
  }

  clear(event = null) {
    event?.preventDefault();

    if (this.input) {
      this.input.value = '';
      this.input.focus();
    }

    this.removeAttribute('results');
    this.toggleSearchState(false);

    if (this.isSearchVisible && !this.searchRecommendationEmpty) {
      this.searchContent?.classList.remove('hidden');
    } else if (this.searchRecommendationEmpty) {
      this.searchContent?.classList.add('hidden');
    }
  }

  handleProductTypeChange() {
    if (!this.isSearchVisible) return;

    const query = this.getQuery();
    if (query.length > 0) {
      const url = this.setupURL().toString();
      this.renderSection(url);
    }
  }

  setupURL() {
    const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
    let search_term = this.getQuery();

    if (this.searchProductTypes && this.searchProductTypes.value !== '') {
      search_term = `product_type:${this.searchProductTypes.value} AND ${encodeURIComponent(search_term)}`;
    }

    url.searchParams.set('q', search_term);
    url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3);
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));

    return url;
  }

  onChange() {
    if (!this.isSearchVisible) return;

    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }

    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    if (!this.isSearchVisible) return;
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText);
    this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    this.setLoadingState(true);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        if (!this.isSearchVisible) return;
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => this.setLoadingState(false));
  }

  renderSearchResults(responseText) {
    if (!this.isSearchVisible) return;

    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(id);

      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;

        if (this.isHeaderSearch && !document.body.classList.contains(this.states.SEARCH_OPEN)) {
          document.body.classList.add(this.states.SEARCH_OPEN);
          this.toggleNavButtonVisibility(false);
        }

        this.classList.add(this.states.OPEN);
      } else {
        console.error(`Element with id '${id}' not found in the parsed response.`);
      }
    } else {
      console.error(`Element with id '${id}' not found in the document.`);
    }
  }

  handleClickOutside(event) {
    const target = event.target;

    if (this.toggleSearchButton?.contains(target)) return;

    const shouldClose = this.isHeaderSearch
      ? !this.contains(target) &&
        ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
          target.classList.contains('header__search-close') ||
          true)
      : !this.contains(target);

    if (shouldClose && this.isSearchVisible) {
      setTimeout(() => this.closeSearchUI());
    }
  }

  toggleSearchState(isOpen) {
    this.classList.toggle(this.states.OPEN, isOpen);

    if (this.isHeaderSearch) {
      document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
      this.toggleNavButtonVisibility(!isOpen);
    }

    if (!isOpen) {
      this.searchContent?.classList.add('hidden');
      if (this.searchRecommendationEmpty) {
        this.searchContent?.classList.add('hidden');
      }
    }
  }

  toggleNavButtonVisibility(isOpen) {
    this.toggleNavigationButton && this.toggleNavigationButton.classList.toggle('is-show', isOpen);
  }

  setLoadingState(isLoading) {
    if (!this.resetButton) return;

    if (isLoading) {
      this.setAttribute('loading', 'true');
      this.resetButton.classList.add(this.states.LOADING);
    } else {
      this.removeAttribute('loading');
      this.resetButton.classList.remove(this.states.LOADING);
      this.setAttribute('results', 'true');
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);